import { Plus } from "lucide-react";

export function AddButton({ onClick, text = "Add" }) {
  return (
    <button
      onClick={onClick}
      className="
        inline-flex items-center gap-2
        px-4 py-2 rounded-lg
        border border-gray-200
        bg-white
        text-sm font-medium text-gray-700
        shadow-sm
        hover:bg-gray-50 hover:border-gray-300
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
        transition-all
      "
    >
      <Plus className="h-4 w-4 text-gray-500" />
      {text}
    </button>
  );
}
